export function getApiErrorMessage(error: unknown): string | null {
  const response = (error as { response?: { data?: { error?: unknown; message?: unknown } } })
    .response;
  const apiError = response?.data?.error;
  if (typeof apiError === 'string' && apiError.trim()) return apiError;
  const apiMessage = response?.data?.message;
  if (typeof apiMessage === 'string' && apiMessage.trim()) return apiMessage;
  return null;
}
